import React from 'react';
import PropTypes from 'prop-types';
import ZohopublicForm from '../../../Form/Zohopublic/Zohopublic';

import './ResourceRegistration.scss';

export default class ResourceRegistration extends React.PureComponent {
    render() {
        const { contentElement } = this.props;

        return (
            <div className="component-Employer-Marketing-ResourceRegistration">
                {contentElement}
                <ZohopublicForm isHidden={false} />
            </div>
        );
    }
}

ResourceRegistration.propTypes = {
    contentElement: PropTypes.node.isRequired,
};

ResourceRegistration.defaultProps = {};
